export default __webpack_public_path__ + "BackgroundImage.f3e909b8.png";